import * as yup from "yup";

export const resetEmailSchema = yup.object({
    email_id: yup.string().email().required(),
})

export const ChangePasswordSchema = yup.object({
    confirm_password: yup.string().required(),
    password: yup.string().required(),
})